export const REQ_TIRES_SUCCES = "REQ_TIRES_SUCCES"
export const REQ_TIRE_SUCCESS = "REQ_TIRE_SUCCESS"
export const PUT_TIRE_SUCCESS = "PUT_TIRE_SUCCESS"
export const DELETE_TIRE_SUCCESS = "DELETE_TIRE_SUCCESS"
export const REQ_TIRES_ERROR = "REQ_TIRES_ERROR"
export const CLEAR_TIRES_SUCCESS = "CLEAR_TIRES_SUCCESS"
export const CLEAR_TIRES_ERROR = "CLEAR_TIRES_ERROR"